import { useEffect, useState } from 'react';

import {
  DialogTitle,
  Grid,
  CircularProgress,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemButton,
  Checkbox,
  List,
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';

import { StandardDialogActions, RoundedDialog } from '../../../../Global/Components';
import axios from 'axios';
import StateManager from '../../../../Global/StateManager';
import Iconfiy from '../../../../iconify';

const CreateAllocationTaskDialog = ({ open, onClose, initial, title = 'Create Allocation Task', documentId }) => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checked, setChecked] = useState([]);
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [saving, setSaving] = useState(false);

  const handleToggle = (value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const onSave = () => {
    setSaving(true);
    const data = { locationIds: checked, documentId };
    axios
      .post('dochub/locations/allocate-task', data)
      .then(() => {
        setSaving(false);
        StateManager.setSuccessAlert(`Allocation task${checked?.length > 1 ? 's' : ''} created successfully`);
        onClose();
      })
      .catch((err) => {
        setSaving(false);
        StateManager.setAxiosErrorAlert(err);
      });
  };

  useEffect(() => {
    if (!open) return;
    setChecked([]);
    setFilteredLocations(initial || []);
    axios
      .get('dochub/locations?withHeriarchy=true')
      .then((res) => {
        setLocations(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        StateManager.setAxiosErrorAlert(err);
      });
  }, [open, initial]);

  if (loading) {
    return (
      <RoundedDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogContent>
          <Grid container justifyContent="center" alignItems="center" sx={{ p: 2 }}>
            <CircularProgress size={30} />
          </Grid>
        </DialogContent>
      </RoundedDialog>
    );
  }

  return (
    <RoundedDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container gap={2}>
          <List sx={{ width: '100%', maxWidth: '100%', bgcolor: 'background.paper' }}>
            {locations
              ?.filter((x) => filteredLocations?.includes(x._id))
              ?.map((location) => (
                <ListItem key={location._id} disablePadding>
                  <ListItemButton role={undefined} onClick={() => handleToggle(location._id)} dense>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={checked.indexOf(location._id) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ 'aria-labelledby': location._id }}
                      />
                    </ListItemIcon>
                    <ListItemText id={location._id} primary={location.path} />
                  </ListItemButton>
                </ListItem>
              ))}
          </List>
        </Grid>
      </DialogContent>
      <StandardDialogActions
        onClose={onClose}
        doneButtonText={checked?.length > 1 ? 'Create tasks' : 'Create task'}
        doneButtonIcon={<Iconfiy icon="eva:checkmark-outline" />}
        onDone={onSave}
        disableDone={checked?.length === 0}
        saving={saving}
      />
    </RoundedDialog>
  );
};
export default CreateAllocationTaskDialog;
